// extracted by mini-css-extract-plugin
module.exports = {"strava":"ManageSettingsButton_strava__Bn9k9","fitbit":"ManageSettingsButton_fitbit__5do8v","manageSettingsButton":"ManageSettingsButton_manageSettingsButton__hOnWO"};